module.exports = __webpack_public_path__ + "static/img/control.c3051d3b.png";